module.exports = __webpack_public_path__ + "static/media/1024984.28cfa240.jpg";